import NameFilter from './NameFilter';

export default NameFilter;
